/**
 * EB 平台端按钮权限（菜单 auth + 用户 access）
 * access 来自 GET sys/profile，与 PHP AdminAuthMiddleware 中权限 route 一致
 */
import useCrmebMenuStore from '@/store/modules/menu';
import useUserStore from '@/store/modules/user';
import { includeArray } from '@/utils/crmebMenu';

/** level=0 主管理员；区域代理 isAgent>0 对齐 PHP checkAuth 放行；access 为空表示不限制（主账号） */
function isCrmebUnrestricted(): boolean {
  const user = useUserStore();
  const level = user.crmebAdminLevel;
  if (level === 0 || level === undefined || level === null) return true;
  if (user.isAgent) return true;
  return false;
}

function hasAuth(value: string | string[]): boolean {
  const access = useCrmebMenuStore().access;
  const list = Array.isArray(value) ? value : [value];
  if (!access?.length) {
    return isCrmebUnrestricted();
  }
  return includeArray(list, access);
}

/** 模板 v-if 用（勿在 el-dropdown-item / router-link 等非单根组件上用 v-eb-auth） */
function authVisible(value?: string | string[]): boolean {
  if (value === undefined || value === null || value === '') return true;
  if (Array.isArray(value)) {
    return value.some((v) => hasAuth(v));
  }
  return hasAuth(value);
}

export default {
  hasAuth,
  hasAuthOr(values: string[]) {
    return values.some((v) => hasAuth(v));
  },
  hasAuthAnd(values: string[]) {
    return values.every((v) => hasAuth(v));
  },
  authVisible,
};
